var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHowToBuy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 29,
    viewBox: "0 0 50 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.937 0.0668945H18.875V3.1785H21.937V0.0668945Z",
    fill: "#16292D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0005 0.0668945H21.9375V3.1785H25.0005V0.0668945Z",
    fill: "#16292D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.063 0.0668945H25V3.1785H28.063V0.0668945Z",
    fill: "#16292D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1245 0.0668945H28.0625V3.1785H31.1245V0.0668945Z",
    fill: "#16292D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8755 3.17847H15.8125V6.29007H18.8755V3.17847Z",
    fill: "#16292D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.937 3.17847H18.875V6.29007H21.937V3.17847Z",
    fill: "#E7E7E7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0005 3.17847H21.9375V6.29007H25.0005V3.17847Z",
    fill: "#E7E7E7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.063 3.17847H25V6.29007H28.063V3.17847Z",
    fill: "#E7E7E7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1245 3.17847H28.0625V6.29007H31.1245V3.17847Z",
    fill: "#B6C9E3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.188 3.17847H31.125V6.29007H34.188V3.17847Z",
    fill: "#16292D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7505 6.28906H9.6875V9.39956H12.7505V6.28906Z",
    fill: "#16292D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.812 6.28906H12.75V9.39956H15.812V6.28906Z",
    fill: "#16292D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8755 6.28906H15.8125V9.39956H18.8755V6.28906Z",
    fill: "#E7E7E7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.937 6.28906H18.875V9.39956H21.937V6.28906Z",
    fill: "#E7E7E7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0005 6.28906H21.9375V9.39956H25.0005V6.28906Z",
    fill: "#E7E7E7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28.063 6.28906H25V9.39956H28.063V6.28906Z",
    fill: "#E7E7E7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1245 6.28906H28.0625V9.39956H31.1245V6.28906Z",
    fill: "#B6C9E3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M34.188 6.28906H31.125V9.39956H34.188V6.28906Z",
    fill: "#B6C9E3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2495 6.28906H34.1875V9.39956H37.2495V6.28906Z",
    fill: "#16292D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M40.313 6.28906H37.25V9.39956H40.313V6.28906Z",
    fill: "#16292D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62554 9.40039H3.5625V12.512H6.62554V9.40039Z",
    fill: "#16292D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M9.68696 9.40039H6.625V12.512H9.68696V9.40039Z",
    fill: "#16292D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7505 9.40039H9.6875V12.512H12.7505V9.40039Z",
    fill: "#16292D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M15.812 9.40039H12.75V12.512H15.812V9.40039Z",
    fill: "#B6C9E3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8755 9.40039H15.8125V12.512H18.8755V9.40039Z",
    fill: "#E7E7E7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M21.937 9.40039H18.875V12.512H21.937V9.40039Z",
    fill: "#E7E7E7"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0005 9.40039H21.9375V12.512H25.0005V9.40039Z",
    fill: "#E7E7E7"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M28.063 9.40039H25V12.512H28.063V9.40039Z",
    fill: "#B6C9E3"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1245 9.40039H28.0625V12.512H31.1245V9.40039Z",
    fill: "#B6C9E3"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M34.188 9.40039H31.125V12.512H34.188V9.40039Z",
    fill: "#B6C9E3"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2495 9.40039H34.1875V12.512H37.2495V9.40039Z",
    fill: "#B6C9E3"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M40.313 9.40039H37.25V12.512H40.313V9.40039Z",
    fill: "#293649"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3745 9.40039H40.3125V12.512H43.3745V9.40039Z",
    fill: "#16292D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M46.438 9.40039H43.375V12.512H46.438V9.40039Z",
    fill: "#16292D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M3.56196 12.511H0.5V15.6215H3.56196V12.511Z",
    fill: "#16292D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62554 12.511H3.5625V15.6215H6.62554V12.511Z",
    fill: "#80ACA1"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M9.68696 12.511H6.625V15.6215H9.68696V12.511Z",
    fill: "#80ACA1"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7505 12.511H9.6875V15.6215H12.7505V12.511Z",
    fill: "#80ACA1"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M15.812 12.511H12.75V15.6215H15.812V12.511Z",
    fill: "#293649"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8755 12.511H15.8125V15.6215H18.8755V12.511Z",
    fill: "#B6C9E3"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M21.937 12.511H18.875V15.6215H21.937V12.511Z",
    fill: "#B6C9E3"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0005 12.511H21.9375V15.6215H25.0005V12.511Z",
    fill: "#B6C9E3"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M28.063 12.511H25V15.6215H28.063V12.511Z",
    fill: "#B6C9E3"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1245 12.511H28.0625V15.6215H31.1245V12.511Z",
    fill: "#B6C9E3"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M34.188 12.511H31.125V15.6215H34.188V12.511Z",
    fill: "#B6C9E3"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2495 12.511H34.1875V15.6215H37.2495V12.511Z",
    fill: "#293649"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M40.313 12.511H37.25V15.6215H40.313V12.511Z",
    fill: "#80ACA1"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3745 12.511H40.3125V15.6215H43.3745V12.511Z",
    fill: "#80ACA1"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M46.438 12.511H43.375V15.6215H46.438V12.511Z",
    fill: "#80ACA1"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4995 12.511H46.4375V15.6215H49.4995V12.511Z",
    fill: "#16292D"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M3.56196 15.6228H0.5V18.7344H3.56196V15.6228Z",
    fill: "#16292D"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62554 15.6228H3.5625V18.7344H6.62554V15.6228Z",
    fill: "#466974"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M9.68696 15.6228H6.625V18.7344H9.68696V15.6228Z",
    fill: "#80ACA1"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7505 15.6228H9.6875V18.7344H12.7505V15.6228Z",
    fill: "#80ACA1"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M15.812 15.6228H12.75V18.7344H15.812V15.6228Z",
    fill: "#FED200"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8755 15.6228H15.8125V18.7344H18.8755V15.6228Z",
    fill: "#293649"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M21.937 15.6228H18.875V18.7344H21.937V15.6228Z",
    fill: "#293649"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0005 15.6228H21.9375V18.7344H25.0005V15.6228Z",
    fill: "#293649"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M28.063 15.6228H25V18.7344H28.063V15.6228Z",
    fill: "#293649"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1245 15.6228H28.0625V18.7344H31.1245V15.6228Z",
    fill: "#293649"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M34.188 15.6228H31.125V18.7344H34.188V15.6228Z",
    fill: "#293649"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2495 15.6228H34.1875V18.7344H37.2495V15.6228Z",
    fill: "#FED200"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M40.313 15.6228H37.25V18.7344H40.313V15.6228Z",
    fill: "#80ACA1"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3745 15.6228H40.3125V18.7344H43.3745V15.6228Z",
    fill: "#80ACA1"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M46.438 15.6228H43.375V18.7344H46.438V15.6228Z",
    fill: "#466974"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4995 15.6228H46.4375V18.7344H49.4995V15.6228Z",
    fill: "#16292D"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62554 18.7334H3.5625V21.8439H6.62554V18.7334Z",
    fill: "#16292D"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M9.68696 18.7334H6.625V21.8439H9.68696V18.7334Z",
    fill: "#466974"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7505 18.7334H9.6875V21.8439H12.7505V18.7334Z",
    fill: "#466974"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M15.812 18.7334H12.75V21.8439H15.812V18.7334Z",
    fill: "#80ACA1"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8755 18.7334H15.8125V21.8439H18.8755V18.7334Z",
    fill: "#80ACA1"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M21.937 18.7334H18.875V21.8439H21.937V18.7334Z",
    fill: "#FAFFFA"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0005 18.7334H21.9375V21.8439H25.0005V18.7334Z",
    fill: "#80ACA1"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M28.063 18.7334H25V21.8439H28.063V18.7334Z",
    fill: "#80ACA1"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1245 18.7334H28.0625V21.8439H31.1245V18.7334Z",
    fill: "#FAFFFA"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M34.188 18.7334H31.125V21.8439H34.188V18.7334Z",
    fill: "#80ACA1"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2495 18.7334H34.1875V21.8439H37.2495V18.7334Z",
    fill: "#80ACA1"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M40.313 18.7334H37.25V21.8439H40.313V18.7334Z",
    fill: "#466974"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3745 18.7334H40.3125V21.8439H43.3745V18.7334Z",
    fill: "#466974"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M46.438 18.7334H43.375V21.8439H46.438V18.7334Z",
    fill: "#16292D"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M9.68696 21.8447H6.625V24.9563H9.68696V21.8447Z",
    fill: "#16292D"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7505 21.8447H9.6875V24.9563H12.7505V21.8447Z",
    fill: "#16292D"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M15.812 21.8447H12.75V24.9563H15.812V21.8447Z",
    fill: "#466974"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8755 21.8447H15.8125V24.9563H18.8755V21.8447Z",
    fill: "#466974"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M21.937 21.8447H18.875V24.9563H21.937V21.8447Z",
    fill: "#466974"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0005 21.8447H21.9375V24.9563H25.0005V21.8447Z",
    fill: "#466974"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M28.063 21.8447H25V24.9563H28.063V21.8447Z",
    fill: "#466974"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1245 21.8447H28.0625V24.9563H31.1245V21.8447Z",
    fill: "#466974"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M34.188 21.8447H31.125V24.9563H34.188V21.8447Z",
    fill: "#466974"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2495 21.8447H34.1875V24.9563H37.2495V21.8447Z",
    fill: "#466974"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M40.313 21.8447H37.25V24.9563H40.313V21.8447Z",
    fill: "#16292D"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3745 21.8447H40.3125V24.9563H43.3745V21.8447Z",
    fill: "#16292D"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M15.812 24.9553H12.75V28.0658H15.812V24.9553Z",
    fill: "#16292D"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8755 24.9553H15.8125V28.0658H18.8755V24.9553Z",
    fill: "#16292D"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M21.937 24.9553H18.875V28.0658H21.937V24.9553Z",
    fill: "#16292D"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0005 24.9553H21.9375V28.0658H25.0005V24.9553Z",
    fill: "#16292D"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M28.063 24.9553H25V28.0658H28.063V24.9553Z",
    fill: "#16292D"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1245 24.9553H28.0625V28.0658H31.1245V24.9553Z",
    fill: "#16292D"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M34.188 24.9553H31.125V28.0658H34.188V24.9553Z",
    fill: "#16292D"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2495 24.9553H34.1875V28.0658H37.2495V24.9553Z",
    fill: "#16292D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHowToBuy);
export default __webpack_public_path__ + "static/media/IconHowToBuy.4912d654378fbd0aa7fdb4a8cdc469ec.svg";
export { ForwardRef as ReactComponent };